import { bindActionCreators } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

const useActionCreators = actionCreators => {
  const dispatch = useDispatch();

  return useMemo(
    () => bindActionCreators(actionCreators, dispatch),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.values(actionCreators)
  );
};

export default useActionCreators;
